<h2
  mat-dialog-title
  style="color: white"
  class="title-text theme-background-color mb-4">
  {{ data?.heading }}
</h2>

<div>
  <form clas="d-flex" [formGroup]="invoiceForm">
    <mat-dialog-content class="mat-typography">
      <div class="row">
        <div class="mb-3" *ngIf="data?.module === 'FINANCE'">
          <label for="currency-radio-group">Currency:</label>
          <br />
          <mat-radio-group
            id="currency-radio-group"
            formControlName="showUsd"
            name="currency">
            <mat-radio-button color="primary" [value]="false"
              >SAR</mat-radio-button
            >
            <mat-radio-button color="primary" [value]="true"
              >SAR and USD</mat-radio-button
            >
          </mat-radio-group>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label for="date"
              >Supply Date <span class="text-danger">*</span></label
            >
            <input
              [owlDateTime]="dt1"
              [min]="minDate"
              [ngClass]="{
                'is-invalid':
                  invoiceForm.get('date')?.hasError('required') &&
                  invoiceForm.get('date')?.touched
              }"
              [owlDateTimeTrigger]="dt1"
              class="form-control"
              formControlName="date"
              placeholder="Select Service Date" />
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
            <span class="error invalid-feedback">Please select a date</span>
          </div>
        </div>

        <div class="col-md-12" *ngIf="data?.isCreditNote">
          <div class="form-group">
            <label for="ebsReason" class="mb-2"
              >EBS Reason <span class="text-danger">*</span></label
            >
            <ng-select
              id="ebsReason"
              name="ebsReason"
              formControlName="ebsReason"
              [items]="reasonOptions"
              bindLabel="reason"
              bindValue="id"
              [searchable]="true"
              [clearable]="true"
              placeholder="Select Reason"
              [ngClass]="{
                'is-invalid':
                  invoiceForm.get('ebsReason')?.hasError('required') &&
                  (invoiceForm.get('ebsReason')?.touched ||
                    invoiceForm.get('ebsReason')?.dirty)
              }">
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div>
                  <span class="rectangle-tag bg-info mr-2">{{
                    item.reason
                  }}</span>
                  <span
                    *ngIf="item.description"
                    class="rectangle-tag bg-success mr-2">
                    {{ item.description }}
                  </span>
                </div>
              </ng-template>
            </ng-select>
            <span
              *ngIf="
                invoiceForm.get('ebsReason')?.hasError('required') &&
                (invoiceForm.get('ebsReason')?.touched ||
                  invoiceForm.get('ebsReason')?.dirty)
              "
              class="error invalid-feedback"
              >Please select a reason</span
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="reason"
              >Zatca Reason <span class="text-danger">*</span></label
            >
            <textarea
              [ngClass]="{
                'is-invalid':
                  invoiceForm.get('reason')?.hasError('required') &&
                  invoiceForm.get('reason')?.touched
              }"
              class="form-control"
              formControlName="reason"
              placeholder="Enter reason"
              rows="2"></textarea>
            <span class="error invalid-feedback">Please enter a reason</span>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions style="gap: 4px" class="flex-d" align="end">
      <button class="btn btn-secondary" type="button" (click)="closeModal()">
        Cancel
      </button>
      <button
        [disabled]="!invoiceForm.valid || processing"
        class="btn btn-primary custom-button"
        type="submit"
        (click)="onSubmit()">
        <ng-container *ngIf="createLoading; else submitText">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"></span>
        </ng-container>
        <ng-template #submitText> Submit </ng-template>
      </button>
    </mat-dialog-actions>
  </form>
</div>
